import { render, staticRenderFns } from "./DialogEditQuota.vue?vue&type=template&id=0607a42f&"
import script from "./DialogEditQuota.vue?vue&type=script&lang=js&"
export * from "./DialogEditQuota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!///node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports